class JobProducer {
  constructor({type,value}) {
    // POST type/
    // { body: body, state: QUEUED,COMPLETED,ERROR, parent: $key }
  }
}
